import api from '../../../services/api';

export const fetchDashboardByProject = async (projectId) => {
  try {
    const response = await api.get(`/dashboard-new/project/${projectId}/byproject`);
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard by project:', error);
    throw error;
  }
};

export const fetchDashboardByUnit = async (projectId) => {
  try {
    const response = await api.get(`/dashboard-new/project/${projectId}/byunit`);
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard by unit:', error);
    throw error;
  }
};

export const fetchDashboardByCategory = async (projectId) => {
  try {
    const response = await api.get(`/dashboard-new/project/${projectId}/bycategory`);
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard by category:', error);
    throw error;
  }
};

export const fetchProjectDashboardData = async (projectId) => {
  try {
    const response = await api.get(`/dashboard/project?projectId=${projectId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project dashboard data:', error);
    throw error;
  }
};

export const fetchUnitDashboardData = async (projectId, unitId) => {
  try {
    const response = await api.get(`/dashboard?projectId=${projectId}&unitId=${unitId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching unit dashboard data:', error);
    throw error;
  }
};

export const fetchProjects = async () => {
  try {
    const response = await api.get('/projects');
    const data = response.data;
    return Array.isArray(data) ? data : (data?.projects || data?.data || []);
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

export const fetchModularUnits = async (projectId) => {
  try {
    const response = await api.get(`/projects/${projectId}/modular-units`);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.modularUnits || data?.units || data?.data || []);
  } catch (error) {
    console.error('Error fetching modular units:', error);
    throw error;
  }
};

export const fetchWorkCategories = async (unitId) => {
  try {
    const response = await api.get(`/modular-units/${unitId}/work-categories`);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.workCategories || data?.categories || data?.data || []);
  } catch (error) {
    console.error('Error fetching work categories:', error);
    throw error;
  }
};

export const fetchTasks = async (categoryId) => {
  try {
    const response = await api.get(`/work-categories/${categoryId}/tasks`);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.tasks || data?.data || []);
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};
